import React, { useMemo } from 'react';
import { Popconfirm } from 'antd';
import styles from './progress-bar.module.scss';
import { Button } from 'src/components/design-system';
import { MenuDocumentIcon } from '../../../../images';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useSelector } from 'react-redux';
import { useAccessiblePopconfirm } from 'src/components/design-system/popconfirm/hooks/use-accessible-popconfirm';

/**
 * @type {React.FC<any>}
 */
const ProgressBar = React.memo(function ProgressBar({
  progress = 0,
  onCancel,
  fileName = 'file',
  isDirectConversion = false,
  onCancelDialogChange,
}) {
  const lang = useSelector(getLang('PROGRESS_BAR'));

  const messages = useMemo(
    () => ({
      titleReady: isDirectConversion ? lang.CONVERT_READY : lang.UPLOAD_READY,
      titleOngoing: isDirectConversion ? lang.CONVERT_ONGOING : lang.UPLOAD_ONGOING,
      cancelButton: isDirectConversion ? lang.CONVERT_CANCEL : lang.CANCEL,
      dismissButton: isDirectConversion ? lang.CONTINUE_CONVERT : lang.CONTINUE_UPLOAD,
      confirmButton: isDirectConversion ? lang.CANCEL_CONVERT : lang.CANCEL_UPLOAD,
    }),
    [lang, isDirectConversion],
  );

  const uploadMessage =
    progress === 100
      ? messages.titleReady.replace('{fileName}', fileName)
      : messages.titleOngoing.replace('{fileName}', fileName).replace('{progress}', progress);

  const popconfirmProps = useAccessiblePopconfirm({
    onConfirm: onCancel,
    onOpenChange: onCancelDialogChange,
  });

  return (
    <div className={styles.progressWrapper}>
      <div className={styles.fileWrapper}>
        <img src={MenuDocumentIcon} alt="document" />
        <p>{uploadMessage}</p>
      </div>
      <div className={styles.progressBar}>
        <div
          className={styles.progressBarFill}
          style={{
            width: `${progress}%`,
          }}
        />
      </div>
      <div className={styles.buttons}>
        <Popconfirm
          title={lang.CANCEL_TITLE}
          cancelText={messages.dismissButton}
          okText={messages.confirmButton}
          okType="danger"
          {...popconfirmProps}
        >
          <Button disabled={progress === 100}>{messages.cancelButton}</Button>
        </Popconfirm>
      </div>
    </div>
  );
});

export { ProgressBar };
